import common from '../common/'
import { reactive } from '@vue/composition-api'
import manageSyncRedirection from './manage-sync-redirection/'
import manageAsyncRedirection from './manage-async-redirection/'
import { state } from '..'

export default ({ registerMessage }={}) => {
  common()
  state.registerMessage = registerMessage
  // manageSyncRedirection({ state })
  // manageAsyncRedirection({ state })
}
